import { LocatorEvent, PinClickEvent, CardClickEvent, PinHoverEvent } from './Events.js';
import { GoogleMapsFree } from 'js/components/Maps/GoogleMapsFree.js';
import { Maps } from 'js/components/Maps/index.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { GoogleMapsEnterprise } from '../../components/Maps/GoogleMapsEnterprise.js';

export class SearchMap extends GoogleMapsEnterprise {
  static initClass() {
    Maps.FactoryForProvider['Google'] = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.SearchMap";
    this.breakPoint = 992;
    this.pinClickCardToTop = true;
    this.pinHoverCardToTop = false;
    this.disablePinHover = false;
    this.isLegacyDesign = false;
  }

  constructor(args) {
    super(args);
    this.pinWidth = 38.663;
    this.pinHeight = 39.813;
    this.mapOptions.disableDoubleClickZoom = false;
    this.mapOptions.scrollwheel = true;
    let defaultMapLocation = this.localeToMapLocations(this.getLocale());
    this.latitude = defaultMapLocation[0];
    this.longitude = defaultMapLocation[1];
    this.isLegacyDesign = this.getLocale().includes('ja');
  }

  getLocale() {
    return document.getElementById('js-map-wrapper').dataset.locale;
  }

  localeToMapLocations(locale) {
    switch(locale) {
      case 'en': return [51.5074, -0.1278]; // London
      case 'de': return [52.5200, 13.4050]; // Berlin
      case 'es': return [40.4168, -3.7038]; // Madrid
      case 'it': return [41.9028, 12.4964]; // Rome
      case 'ja_JP': return [35.6762, 139.6503]; // Tokyo
      case 'nl': return [50.8503, 4.3517]; // Brussels
      default: return [48.8566, 2.3522]; // Paris
    }
  }

  mapOffset() {
    return {
      top: this.BUFFER,
      bottom: this.BUFFER,
      left: this.BUFFER,
      right: this.BUFFER
    };
  }

  isIE() {
    var ms_ie = false;
    var ua = window.navigator.userAgent;
    var old_ie = ua.indexOf('MSIE ');
    var new_ie = ua.indexOf('Trident/');

    if ((old_ie > -1) || (new_ie > -1)) {
      ms_ie = true;
    }

    return ms_ie;
  }

  isEdge() {
    var ms_edge = false;
    var ua = window.navigator.userAgent;
    var edge = ua.indexOf('Edge/');

    if (edge > -1) {
      ms_edge = true;
    }

    return ms_edge;
  }

  setupMarkerClustering(map, pins) {
    let options = { 'minimumClusterSize': 5 };
    if (window.MarkerClusterer != null) {
      window.markerClusterer = new MarkerClusterer(map, pins, options);
      window.markerClusterer.setGridSize(30);

      let defaultClustererStyles = [{
        url: `${this.config.baseUrl}${require('assets/images/icon-pin-cluster.svg')}`,
        height: 37.814,
        width: 27.2,
        anchor: [6, 0],
        textColor: 'black',
        textSize: 10,
        paddingTop: "6px"
      }];

      return markerClusterer.setStyles(defaultClustererStyles);
    }
  }


  svgPin(label, backgroundColor) {

    let x = this.pinWidth / 2;
    // Manually adjust IE and Edge Pin Text Positioning
    if (this.isIE() || this.isEdge()) {
      x = 18;
    }

    return `<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px" y="0px"
                 width="${this.pinWidth}"
                 height="${this.pinHeight}"
                 viewBox="0 0 ${this.pinWidth} ${this.pinHeight}"
                 enable-background="new 0 0 ${this.pinWidth} ${this.pinHeight}" xml:space="preserve">
              <filter  id="AI_FlouGaussien_1">
                <feGaussianBlur  stdDeviation="1"></feGaussianBlur>
              </filter>
              <g opacity="0.15" filter="url(#AI_FlouGaussien_1)">
                <path fill="#010202" d="M35.794,26.81c-1.887-1.72-8.571-1.72-14.931,0c-5.186,1.4-8.552,3.511-8.598,5.175v0.009l0.742,6.594
                  l17.221-6.342c0.168-0.06,0.332-0.121,0.494-0.182l0.213-0.078h-0.009C35.211,30.321,37.334,28.21,35.794,26.81z"/>
              </g>
              <path fill="${backgroundColor}" d="M22.191,3.808c-5.076-5.077-13.307-5.077-18.383,0C-0.33,7.944-1.096,14.177,1.512,19.091l0.016,0.026
                L13,38.588L24.045,19.86c0.111-0.179,0.217-0.356,0.318-0.538l0.136-0.231h-0.011C27.097,14.177,26.33,7.944,22.191,3.808z"/>
              <circle fill="${backgroundColor}" cx="12.998" cy="12.375" r="7.977"/>
              <path fill="#FFFFFF" d="M14.343,16.562c1.253-0.376,2.466-0.74,3.901-0.357c-0.434-2.375-1.398-5.236-3.5-7.448
                c0.35,3.008-0.096,5.762-1.307,8.067C13.747,16.741,14.047,16.651,14.343,16.562z M6.719,14.107
                c-0.029-0.269-0.044-0.542-0.041-0.82c0.036-3.244,2.387-5.919,5.463-6.476C10.852,9.978,8.762,12.458,6.719,14.107z M13.418,6
                c-0.005,0-0.01,0-0.015,0c-0.154-1-0.31-1.243-0.427-1.586c-0.109,0.474-0.238,0.819-0.383,1.27
                c-3.939,0.367-7.045,3.603-7.09,7.649c-0.006,0.555,0.046,1.069,0.15,1.594c-0.166,0.112-0.33,0.204-0.492,0.304
                c3.227,2.004,5.846,2.192,7.43,1.798c1.93-3.247,1.797-6.894,1.334-9.398c-0.053-0.284-0.121-0.595-0.2-0.912
                c3.524,0.207,6.3,3.148,6.261,6.717c-0.012,1.128-0.307,2.188-0.812,3.113l0,0c-0.003,0.006-0.153,0.281-0.335,0.546
                c-1.6-0.735-2.847-0.36-4.313,0.082c-1.997,0.601-4.391,1.321-8.363-0.666c1.2,2.726,3.91,4.643,7.08,4.678
                c4.325,0.048,7.869-3.185,7.917-7.508C21.209,9.357,17.742,6,13.418,6z"/>
            </svg>
            `;
  }

  svgPinStriped(label, backgroundColor) {

    return `<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px" y="0px"
	               width="${this.pinWidth}"
                 height="${this.pinHeight}" viewBox="0 0 ${this.pinWidth} ${this.pinHeight}" enable-background="new 0 0 ${this.pinWidth} ${this.pinHeight}" xml:space="preserve">
              <filter  id="AI_FlouGaussien_1">
                <feGaussianBlur  stdDeviation="1"></feGaussianBlur>
              </filter>
              <g opacity="0.15" filter="url(#AI_FlouGaussien_1)">
                <path fill="#010202" d="M35.828,26.811c-1.887-1.721-8.571-1.721-14.931,0c-5.186,1.4-8.552,3.511-8.598,5.175v0.009l0.742,6.594
                  l17.221-6.342c0.168-0.061,0.332-0.121,0.494-0.183l0.213-0.078h-0.009C35.245,30.321,37.368,28.211,35.828,26.811z"/>
              </g>
              <g>
                <path fill="${backgroundColor}" d="M22.19,3.808C17.114-1.27,8.885-1.27,3.81,3.808c-4.141,4.137-4.905,10.369-2.297,15.283l0.015,0.025
                  l11.474,19.471l11.044-18.728c0.111-0.178,0.216-0.355,0.317-0.538l0.137-0.23h-0.011C27.097,14.177,26.33,7.944,22.19,3.808z"/>
                <g>
                  <path fill="#FFFFFF" d="M0.036,14h25.929c0.05-2-0.072-3-0.333-4H0.37C0.107,11-0.015,12,0.036,14z"/>
                  <path fill="#FFFFFF" d="M3.81,3.919C2.955,4.773,2.279,6,1.714,7h22.573c-0.566-1-1.242-2.227-2.097-3.081
                    C21.959,3.688,21.714,3,21.469,3H4.53C4.287,3,4.041,3.688,3.81,3.919z"/>
                  <polygon fill="#FFFFFF" points="4.378,24 6.422,28 19.585,28 21.63,24 		"/>
                  <polygon fill="#FFFFFF" points="15.496,35 17.541,31 8.465,31 10.508,35 		"/>
                  <path fill="#FFFFFF" d="M0.649,17c0.23,1,0.51,1.413,0.863,2.08l0.015,0.287L2.335,21h21.34l0.37-0.884
                    c0.111-0.179,0.216-0.53,0.317-0.712L24.499,19h-0.011c0.354,0,0.634-1,0.863-2H0.649z"/>
                </g>
                <circle fill="${backgroundColor}" cx="12.976" cy="12.375" r="9.31"/>
              </g>
              <path fill="#FFFFFF" d="M14.357,15.382c1.253-0.376,2.466-0.74,3.901-0.356c-0.434-2.376-1.398-5.236-3.5-7.448
                c0.35,3.009-0.096,5.762-1.307,8.067C13.762,15.562,14.062,15.472,14.357,15.382z M6.733,12.928
                c-0.029-0.269-0.044-0.542-0.041-0.819c0.036-3.244,2.387-5.92,5.463-6.476C10.866,8.798,8.776,11.278,6.733,12.928z M13.433,5
                c-0.005,0-0.01,0-0.015,0c-0.154-1-0.31-1.332-0.427-1.676c-0.109,0.474-0.238,0.773-0.383,1.225
                c-3.939,0.367-7.045,3.581-7.09,7.627c-0.006,0.556,0.046,1.058,0.15,1.583c-0.166,0.112-0.33,0.199-0.492,0.299
                c3.227,2.004,5.846,2.189,7.43,1.795c1.93-3.247,1.797-6.895,1.334-9.399c-0.053-0.284-0.121-0.596-0.2-0.913
                c3.524,0.206,6.3,3.147,6.261,6.717c-0.012,1.128-0.307,2.187-0.812,3.113l0,0c-0.003,0.006-0.153,0.28-0.335,0.546
                c-1.6-0.735-2.847-0.36-4.313,0.082c-1.997,0.601-4.391,1.32-8.363-0.666c1.2,2.726,3.91,4.644,7.08,4.678
                c4.325,0.048,7.869-3.095,7.917-7.418C21.224,8.268,17.757,5,13.433,5z"/>
            </svg>
            `;
  }

  preparePin(i, loc, m) {
    let pin = super.preparePin(...arguments);
    pin.isDefault = true;

    if (!this.constructor.disablePinHover) {
      pin.addListener('mouseover', () => {
        this.hoverHandler(true, loc, pin, i, m);
      });
      pin.addListener('mouseout', () => {
        this.hoverHandler(false, loc, pin, i, m);
      })
    }

    let changeColor = (needsHighlight) => {
      let hasHighlight = !pin.isDefault;
      if (needsHighlight && !hasHighlight) {
        pin.setIcon(this.iconImage(loc, i, true));
        pin.isDefault = false;
        pin.setZIndex(1);
      } else if (!needsHighlight && hasHighlight) {
        pin.setIcon(this.iconImage(loc, i, false));
        pin.isDefault = true;
        pin.setZIndex(0);
      }
      else {}
        //do nothing
    };

    let needsHighlight = (e, type) => {
      let basicNeeds = e.detail.yextId === `js-yl-${loc.id}`;
      if (type !== 'hover') {
        return basicNeeds;
      }
      return basicNeeds && e.detail.active;
    }

    document.addEventListener(CardClickEvent.eventTypeName, (event) => {
      changeColor(needsHighlight(event));
    });

    document.addEventListener(PinClickEvent.eventTypeName, (event) => {
      changeColor(needsHighlight(event));
    });
    document.addEventListener(PinHoverEvent.eventTypeName, (event) => {
      changeColor(needsHighlight(event, 'hover'));
    });

    return pin;
  }

  prepareMap() {
    this.boundsForPins = new google.maps.LatLngBounds();
    this.infowindow = new google.maps.InfoWindow();

    this.mapOptions.zoomControlOptions =
      {position: google.maps.ControlPosition.RIGHT_BOTTOM};

    if (this.config.controlOptions != null) {
      let object = this.config.controlOptions();
      for (let option in object) {
        let config = object[option];
        this.mapOptions[option] = config;
      }
    }

    this.map = new google.maps.Map(this.element, this.mapOptions);
    this.pins = [];
    let idx = 0;

    for (let location of Array.from(this.allLocations)) {
      let pin = this.preparePin(idx, location, this.map);
      this.boundsForPins.extend(pin.position);
      this.pins.push(pin);
      idx++;
    }

    this.setupMarkerClustering(this.map, this.pins);

    google.maps.event.addListener(this.map, "click", () => {
      if (this.infowindow != null) { this.infowindow.close(); }
    });

    if (this.allLocations.length === 0) {
      window.google.maps.event.addListenerOnce(this.map, 'idle', () => {
        this.map.setZoom(this.config.zoom);
        return this.setOffsetCenter(new google.maps.LatLng({lat: this.latitude, lng: this.longitude}), this.mapOffset());
      });
    }

    window.google.maps.event.addListenerOnce(this.map, 'idle', () => {
      this.setMapBounds();
      this.mapLoaded();
    });

    OptimizedResizeInstance.on( () => {
      if(this.element.classList.contains('js-map-ready')) {
        this.setMapBounds();
      }
    });

    // Enable the 'requery' button when user interacts with the map
    ['mouseup', 'dragend'].forEach((e) => {
      google.maps.event.addListener(this.map, e, () => {
        document.querySelector('.c-map-requery-button').classList.remove('js-hidden');
      });
    });

    // Trigger a search at the center of the map
    document.querySelector('.c-map-requery-button').addEventListener('click', (e) => {
      let input = document.querySelector('.search-input');
      let form = document.querySelector('#js-search');
      let centerLat = this.map.getCenter().lat();
      let centerLng = this.map.getCenter().lng();
      let query = `${centerLat},${centerLng}`;

      input.name = 'qp';
      let q = document.createElement('input');
      q.name ='q';
      q.type = 'hidden';
      q.value = query;
      form.appendChild(q);
      return form.submit();
    });

    return this.map;
  }

  clickHandler(loc, pin, index, map) {
    let target = `js-yl-${loc.id}`;
    document.dispatchEvent(new PinClickEvent(target));

    if (window.innerWidth < this.constructor.breakPoint) {
      Yext.Analytics.trackEvent('mappin');
      const newWindow = window.open();
      newWindow.opener = null;
      newWindow.location = Yext.BaseUrl + loc.url;
    }
  }

  hoverHandler(active, loc, pin, index, map) {

    let target = `js-yl-${loc.id}`;
    document.dispatchEvent(new PinHoverEvent(target, active));
  }

  iconImage(loc, i, highlightStatus) {
    let backgroundColor;
    let iconUrl;    

    if(this.isLegacyDesign) {
      if (highlightStatus) {
        backgroundColor = '#00409';
      } else {
        switch (loc.type) {
          case 'succursale':
          case 'COAF':
          case 'franchise':
          case 'monomarque':
            backgroundColor = '#1E3259';
            break;
          case 'concession':
          case 'corner':
            backgroundColor = '#F3CF27';
            break;
          case 'MU':
            backgroundColor = '#E63A1C';
            break;
          case 'multimarque':
            backgroundColor = '#2587C1';
            break;
        }
      }
      if (backgroundColor == null) { backgroundColor = '#1E3259'; }
      if (loc.type == 'multimarque') {
        iconUrl = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPinStriped(i+1, backgroundColor))}`;
      } else {
        iconUrl = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin(i+1, backgroundColor))}`;
      }
    }
    else{
      if (highlightStatus) {
        backgroundColor = '#00409';
      } else {
        switch (loc.type) {
          case 'succursale':
            backgroundColor = '#1E3259';
            break;
          case 'COAF':
          case 'franchise':
          case 'monomarque':
          case 'concession':
          case 'corner':
          case 'multimarque':
            backgroundColor = '#2587C1';
            break;
          case 'MU':
            backgroundColor = '#E63A1C';
            break;
        }
      }
      if (backgroundColor == null) { backgroundColor = '#1E3259'; }

      if (['COAF','franchise','monomarque','concession','corner','multimarque'].includes(loc.type)) {
        iconUrl = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPinStriped(i+1, backgroundColor))}`;
      } else {
        iconUrl = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin(i+1, backgroundColor))}`;
      }
    }


    return {
      url: iconUrl,
      scaledSize: new google.maps.Size(this.pinWidth,this.pinHeight)
    };
  }
}

SearchMap.initClass();

let registerClickHandlers = function() {
  let results = document.getElementsByClassName('js-location-result');
  for (let result of Array.from(results)) {
    result.addEventListener('click', function() {
      if (!(window.innerWidth >= SearchMap.breakPoint)) { return; }
      document.dispatchEvent(new CardClickEvent(this.getAttribute('id')));
    });
    result.addEventListener('mouseenter', function() {
      if (!(window.innerWidth >= SearchMap.breakPoint)) { return; }
      document.dispatchEvent(new PinHoverEvent(this.getAttribute('id')));
    });
  }

  document.addEventListener(PinClickEvent.eventTypeName, function(e) {

    let id = e.detail.yextId;
    if (id == null) { return; }
    document.getElementById(id).classList.add('is-active');
    let toRemove = document.querySelectorAll(`.js-location-result.is-active:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-active');
    }
    if (SearchMap.pinClickCardToTop) {
      window.location.hash = `#${id}`;
    }
  });

  document.addEventListener(CardClickEvent.eventTypeName, function(e) {

    let id = e.detail.yextId;
    if (id == null) { return; }
    document.getElementById(id).classList.toggle('is-active');
    let toRemove = document.querySelectorAll(`.js-location-result.is-active:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-active');
    }
  });

  document.addEventListener(PinHoverEvent.eventTypeName, function(e) {

    let id = e.detail.yextId;
    if (id == null) { return; }
    document.getElementById(id).classList.add('is-active');
    let toRemove = document.querySelectorAll(`.js-location-result.is-active:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-active');
    }
    if (SearchMap.pinHoverCardToTop) {
      window.location.hash = `#${id}`;
    }
  });
};

let registerMapToggling = function() {
  let buttons = document.querySelectorAll('.js-result-toggle');
  for (var button of Array.from(buttons)) {
    button.addEventListener('click', function() {
      document.body.classList.toggle('map-visible');
      document.dispatchEvent(new Event('toggle-map'));
    });
  }

  document.addEventListener('toggle-map', function() {
    for (button of Array.from(buttons)) {
      let disabled = button.getAttribute('disabled');
      if (disabled != null) { button.removeAttribute('disabled'); }
      if ((disabled == null)) { button.setAttribute('disabled', ''); }
    }
  });
};

export const MapSetup = () => {
  registerClickHandlers();
  registerMapToggling();
}
